module.exports = __webpack_public_path__ + "static/media/farm.cb09df34.png";